import { render, staticRenderFns } from "./DisasterPeopleInformation.vue?vue&type=template&id=e4f031d4&scoped=true"
import script from "./DisasterPeopleInformation.vue?vue&type=script&lang=js"
export * from "./DisasterPeopleInformation.vue?vue&type=script&lang=js"
import style0 from "./DisasterPeopleInformation.vue?vue&type=style&index=0&id=e4f031d4&prod&scoped=true&lang=css"
import style1 from "./DisasterPeopleInformation.vue?vue&type=style&index=1&id=e4f031d4&prod&lang=css"
import style2 from "./DisasterPeopleInformation.vue?vue&type=style&index=2&id=e4f031d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f031d4",
  null
  
)

export default component.exports